import store from '../store/index.js';
export default {
  apiUrl() {
    return store.getters['companyModule/currentCompanyApiUrl'];
  }
};
